import { render } from "./StepHome.vue?vue&type=template&id=15fd3c70&scoped=true&bindings={}"
import script from "./StepHome.vue?vue&type=script&lang=ts"
export * from "./StepHome.vue?vue&type=script&lang=ts"

import "./StepHome.vue?vue&type=style&index=0&id=15fd3c70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15fd3c70"

export default script